import React from 'react'

import JobAlert from './JobAlert'

class JobAlerts extends React.Component {
  constructor() {
    super()

    this.state = {
      data: [],
      meta: {},
      isDataFetched: false,
    }

    this.closeJobAlert = this.closeJobAlert.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()
    this.fetchData()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchData() {
    axios.get('/api/internal/job-alerts', { cancelToken: this.cancelSource.token })
      .then((response) => this.onFetchSuccess(response))
      .catch((error) => {})
  }

  setClosed(id) {
    axios.put(`/api/internal/job-alerts/${id}/close`, { cancelToken: this.cancelSource.token })
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    this.setState({
      data: response.data.data,
      meta: response.data.meta,
      isDataFetched: true,
    })
  }

  closeJobAlert(jobAlertToRemove) {
    this.setState({
      data: this.state.data.filter((jobAlert) => jobAlert !== jobAlertToRemove),
    }, () => this.setClosed(jobAlertToRemove.id))
  }

  render() {
    return (
      this.state.isDataFetched
        && this.state.data.map((jobAlert) => (
          <JobAlert
            key={`${jobAlert.type}-${jobAlert.id}`}
            url={`/profile/projects/${jobAlert.attributes.jobId}`}
            message={jobAlert.attributes.message}
            onClose={() => this.closeJobAlert(jobAlert)}
          />
        ))
    )
  }
}

export default JobAlerts
